<template>
  <div ref="pdfWrapper" class="pdf-container">
    <div
      class="pdf-add-wrapper"
      :style="{ transform: `scale(${scale})`, transformOrigin: 'top left' }"
    >
      <b-row
        class="pdf-add-row invoice"
        v-for="(page, pageIndex) in pages"
        :key="'page' + pageIndex"
        style="margin-bottom: 0; padding-bottom: 0"
      >
        <!-- Col: Left (Invoice Container) -->
        <b-col
          class="pdf-add"
          cols="12"
          style="margin-bottom: 0; padding-bottom: 0"
        >
          <b-card no-body class="pdf-preview-card">
            <!-- Header -->
            <div
              class="pdf_header pdf-padding pt-2"
              style="margin-bottom: 0; padding-bottom: 0"
            >
              <div class="logo">
                <img class="d-block mx-auto" :src="info.logo_url" />
                <h2 class="mx-auto d-table mt-1">
                  <template v-if="pdfData.invoice_type_id == 1">銷售</template>
                  <template v-else-if="pdfData.invoice_type_id == 2"
                    >維修</template
                  >發票 Invoice
                </h2>
              </div>

              <div class="license color0">
                <div class="license-content" v-html="info.company_info"></div>
                <!-- <div>屋宇署註冊小型工程承建商</div>
                <div>MWC3649/2011</div>
                <div>機電工程署電業承辦商</div>
                <div>026812</div> -->
              </div>
              <img
                class="paid_stamp"
                v-if="pdfData.total_paid - pdfData.amount == 0"
                src="@/assets/images/logo/paid_invoice.png"
              />
              <div class="pdf-form">
                <b-row class="form-item">
                  <b-col clas="left" cols="7">
                    <b-row>
                      <b-col cols="3" class="text-right title"> 客戶： </b-col>
                      <b-col cols="9" class="text">
                        <div class="form-value">
                          {{ pdfData.name_cn }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col clas="right" cols="5">
                    <b-row>
                      <b-col cols="4" class="text-right title">
                        發票編號：
                      </b-col>
                      <b-col cols="8" class="text">
                        <div class="form-value pdf-number colorRed" style="overflow: hidden; text-overflow: ellipsis;">
                          <span class="text-nowrap">{{ pdfData.invoice_number }}<label class="text-muted white-space-nowrap">{{pdfData.invoice_number_remark }}</label></span> 
                        </div>
                       
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="form-item">
                  <b-col clas="left" cols="7">
                    <b-row>
                      <b-col cols="3" class="text-right title">
                        工程地址：
                      </b-col>
                      <b-col cols="9" class="text">
                        <div class="form-value">
                          {{ pdfData.address }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col clas="right" cols="5">
                    <b-row>
                      <b-col cols="4" class="text-right title">
                        發單日期：
                      </b-col>
                      <b-col cols="8" class="text">
                        <div class="form-value">
                          {{ pdfData.invoice_date }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="form-item mb-1">
                  <b-col clas="left" cols="7">
                    <b-row>
                      <b-col cols="3" class="text-right title">
                        聯絡電話：
                      </b-col>
                      <b-col cols="9" class="text">
                        <div class="form-value">
                          {{ pdfData.mobile }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
            <!-- Spacer -->
            <div
              class="pdf-padding form-item-section"
              style="padding-top: 0; padding-bottom: 0; margin-bottom: 0"
            >
              <!-- :style="{ height: controlValue.minHeight + 'cm' }" -->
              <div class="pdf-table invoice" style="height: 540px">
                <div class="line a"></div>
                <div class="line b"></div>
                <div class="line c"></div>
                <div class="line d"></div>
                <!-- <div class="line e"></div> -->
                <div class="d-flex">
                  <div class="thead-label">NO.</div>
                  <div class="thead-label">摘要 Description</div>
                  <div class="thead-label">數量</div>
                  <!-- <div class="thead-label">尺寸</div> -->
                  <div class="thead-label">單價 Cost</div>
                  <div class="thead-label">金額(HK$)</div>
                </div>
                <!-- <div class="d-flex">
                  <b-col cols="12" md="1" class="thead-label"> NO. </b-col>
                  <b-col cols="12" md="5" class="thead-label">
                    Description 摘要
                  </b-col>
                  <b-col cols="12" md="2" class="thead-label"> 數量 QTY </b-col>
                  <b-col cols="12" md="2" class="thead-label"> 單價 Cost </b-col>
                  <b-col cols="12" md="2" class="thead-label"> 金額(HK$) </b-col>
                </div> -->

                <div
                  v-for="(item, index) in page"
                  :key="index"
                  ref="row"
                  class="d-flex pdf-item"
                >
                  <div class="pdf-item-text-wrapper">
                    <span
                      class="pdf-item-text"
                      v-if="item.amount >= 0 && !item.is_remark"
                      >{{ item.count }}</span
                    >
                  </div>
                  <div class="pdf-item-text-wrapper">
                    <span
                      class="pdf-item-text"
                      v-html="changeNextLine(item.item_description)"
                    ></span>
                    <!-- <b-form-textarea
                      v-model="item.item_description"
                      class="pdf-item-text"
                      max-rows="200"
                    /> -->
                  </div>
                  <div class="pdf-item-text-wrapper">
                    <div
                      v-if="item.amount >= 0 && !item.is_remark"
                      class="pdf-item-text d-flex justify-content-around"
                    >
                      <span>{{ parseFloat(Number(item.quantity).toString()) }}</span>
                      <span style="width: 20px">{{
                        item.product && item.product.product_unit ? item.product.product_unit.name : '次'
                      }}</span>
                    </div>
                  </div>
                  <!-- <div class="pdf-item-text-wrapper">
                  <span class="pdf-item-text">{{
                    item.product && item.product.size
                  }}</span>
                </div> -->
                  <div class="pdf-item-text-wrapper">
                    <span v-if="!item.is_remark" class="pdf-item-text">HK${{
                      formatMoney(item.unit_price || 0)
                    }}</span>
                  </div>
                  <div class="pdf-item-text-wrapper">
                    <span v-if="!item.is_remark"
                      class="pdf-item-text text-right normal-text"
                      >HK${{ formatMoney(item.amount || 0) }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="pdf-table-amount-wrapper">
                <!-- <div class="pdf-table-amount">
                  <div></div>
                  <span class="total-amount">{{
                    getNumberFormat(pdfData.amount)
                  }}</span>
                </div>
                <div class="pdf-table-amount">
                  <div></div>
                  <span class="total-amount">{{
                    getNumberFormat(Number(pdfData.coupon_discount))
                  }}</span>
                </div>
                <div class="pdf-table-amount">
                  <div></div>
                  <span class="total-amount">{{
                    getNumberFormat(Number(pdfData.gift_voucher_discount))
                  }}</span>
                </div> -->
                <div
                  class="pdf-table-amount"
                  :class="{ 'not-finish': pageIndex < pages.length - 1 }"
                >
                  <div></div>
                  <span
                    v-if="pageIndex == pages.length - 1"
                    class="total-amount"
                    >{{ getNumberFormat(pdfData.amount) }}</span
                  >
                  <span v-else class="total-amount">轉下頁</span>
                </div>
              </div>
            </div>
            <!-- Footer & Payment Detail -->
            <div class="pdf-padding pdf-footer">
              <div class="pdf-form sign">
                <div class="d-flex w-100 form-item mb-50">
                  <div class="box d-flex">
                    <div class="title">客戶簽署：</div>
                    <div class="text">
                      <div class="form-value dotted"></div>
                    </div>
                  </div>
                  <div class="box d-flex">
                    <div class="title">
                      <template v-if="pdfData.invoice_type_id == 1">
                        工程經理簽署：
                      </template>
                      <template v-else-if="pdfData.invoice_type_id == 2">
                        經手人簽署：
                      </template>
                    </div>
                    <div class="text">
                      <div class="form-value dotted"></div>
                    </div>
                  </div>
                </div>
                <div class="d-flex form-item">
                  <div class="box">
                    <div class="d-flex">
                      <div class="title">簽署日期：</div>
                      <div class="text">
                        <div class="form-value dotted">
                          <!-- {{ controlValue.sign_date }} -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box">
                    <div class="d-flex">
                      <div style="margin-left: 24px" class="title">
                        簽署日期：
                      </div>
                      <div class="text">
                        <img v-if="info.stamp_url" class="stamp_logo" :src="info.stamp_url" alt="" />
                        <div class="form-value dotted">
                          <template v-if="info.stamp_url">{{
                            controlValue.sign_date
                          }}</template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="pdfData.invoice_type_id == 1"
                  class="mt-0 text-left remark"
                >
                  <label class="colorBlack" style="font-size: 11px"
                    >備註:</label
                  >
                  <pre class="" v-html="pdfData.invoice_remark">
                    <!-- <li>
                      客戶請先細閱背頁客戶需知,，簽署或付款後即表示無條件同意接受本發票及背頁客戶知，本司將安排各項目訂購及工事宜。
                    </li>
                    <li>
                      本司將按照慣常施工方法生產或安裝，若有特別生產方案將會於施工圖上及單據上列出，本司只包括有電梯及距離車邊5分鐘內搬運服務。(除註有)
                    </li>
                    <li>
                      安裝非本司生產或安裝由客戶提供物品需另議收費，若有損壞或外觀問題責任，由客方���。及不包括任何搬運服務。(除註有)
                    </li>
                    <li>
                      本發票以總計金額計來訂50%，完工前或送貨當天支付餘額50%貨款。所有已經收到貨款將會另發收據以資識別。
                    </li>
                    <li>
                      客戶若有特殊生產要求或安裝，需在報價階段時或施工前向本司說明。任何情況下未繳清貨款總額，產品擁有權仍屬本司，及即時中止所有保險、
                      保用服務。並保留追收已承造項目或服務貨款，已經進行中或已安排項目，將不可退訂或取消。
                    </li>
                    <li>
                      支票抬頭人請註明『 永發設計工程有限公司 』或『 WING FAT
                      DESIGN CONTRACTING LTD 』({{ info.bank_info }})
                    </li> -->
                  </pre>
                </div>
                <div v-else class="mt-0 text-left remark">
                  <label class="colorBlack" style="font-size: 11px"
                    >備註:</label
                  >
                  <pre class="" v-html="pdfData.invoice_remark">

                    <!-- <li>客戶簽署後即代表已檢查上述之項目並確認無誤並收妥。</li>
                    <li>
                      維修項目資料，本司保留發放副本給相關第三者或管業公司存檔。
                    </li>
                    <li>
                      維修項目局部修補，客戶需接受色差、不完整或指定物料由客戶開工日前自備。
                    </li>
                    <li>施工日前收藏物品、保護設施及完工清潔由客戶自備。</li>
                    <li>
                      本司將按照慣常施工方法生產或安裝，若有特別生產方案將會予施工圖上及單據上列出，敬請注意。
                    </li>
                    <li>
                      維修項目，客戶確認惠顧項目，如屬受保修範圍項目內，睇位及維修費用全免。
                      (如非保修範圍內項目，客戶需即場繳付港幣$400-睇位服務費用。)
                    </li> -->
                  </pre>
                </div>

                <!-- Payment Steps Section -->
              

                <hr class="w-100" />
                <div class="d-flex company-info flex-wrap mb-0">
                  <div class="w-50">
                    <div class="d-flex">
                      <span>地址：</span>
                      <span>{{ info.address }}</span>
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="d-flex">
                      <span>網址：</span>
                      <span>{{ info.website }}</span>
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="d-flex">
                      <span>電話：</span>
                      <span>{{ info.phone }}</span>
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="d-flex">
                      <span>電郵：</span>
                      <span>{{ info.email }}</span>
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="d-flex">
                      <span>傳真：</span>
                      <span>{{ info.fax }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pdf-bottom">
              {{ `P.${pageIndex + 1}/${pages.length}` }}
            </div>
          </b-card>
        </b-col>
        <!-- :class="pageIndex == pages.length - 1 ? 'mb-2' : ''" -->
        <b-col cols="12">
          <NoticeToCustomers />
        </b-col>
      </b-row>
    </div>
  </div>
</template>    

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardText,
  BFormTextarea,
  BFormInput,
} from "bootstrap-vue";

import { mapFields } from "vuex-map-fields";
import { formatMoney } from "@/libs/helper.js";
import NoticeToCustomers from "./NoticeToCustomers.vue";
import { ref, watch, onMounted, onUnmounted } from "@vue/composition-api";
import { buildPages, measureRowHeight } from "@/libs/pdf-pagination";

// 發票表格的排版尺寸，需與 style.scss 的 .pdf-table / .pdf-item-text-wrapper 一致
const TABLE_BODY_HEIGHT = 500; // 表格 540px 扣邊框及單行表頭（約 37px）
const NO_WIDTH = 40; // NO. 欄
const DESCRIPTION_WIDTH = 342; // 摘要欄 347px 扣 5px padding-left
const QUANTITY_WIDTH = 45; // 數量欄 65px 扣單位 span 20px
const UNIT_WIDTH = 20; // 單位 span 固定 20px，多字單位會換行
const PRICE_WIDTH = 107; // 單價／金額欄 110px 扣 3px padding-right

export default {
  data() {
    return {
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      pages: [],
    };
  },
  methods: {
    formatMoney,
    changeDate(dateToChange) {
      var newDate = new Date(dateToChange);
      newDate.toLocaleString("default", { month: "long" });
      return (
        newDate.getDate() +
        " " +
        this.month[newDate.getMonth()] +
        " " +
        newDate.getFullYear()
      );
    },
    getNumberFormat(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HKD",
        minimumFractionDigits: 2, // 確保總是顯示2位小數
        maximumFractionDigits: 2, // 限制最多2位小數
      });
      return formatter.format(amount);
    },
    changeNextLine(str) {
      // 處理不同的資料類型
      if (!str) {
        return "";
      }

      // 如果是字串，直接處理
      if (typeof str === 'string') {
        return str.replace(/\n/g, "<br>");
      }

      // 如果是物件且有 content 屬性（例如備註物件）
      if (typeof str === 'object' && str.content) {
        return typeof str.content === 'string' ? str.content.replace(/\n/g, "<br>") : "";
      }

      // 如果是物件且有 title 屬性
      if (typeof str === 'object' && str.title) {
        return typeof str.title === 'string' ? str.title.replace(/\n/g, "<br>") : "";
      }

      // 如果是數字或其他原始類型，轉換為字串
      if (typeof str === 'number' || typeof str === 'boolean') {
        return String(str);
      }

      // 如果是陣列，嘗試連接元素
      if (Array.isArray(str)) {
        return str.map(item =>
          typeof item === 'string' ? item :
          (typeof item === 'object' && item.content) ? item.content :
          String(item)
        ).join('<br>');
      }

      // 其他情況，嘗試轉換為字串
      try {
        const stringValue = String(str);
        return stringValue !== '[object Object]' ? stringValue : "";
      } catch (error) {
        console.warn('changeNextLine: 無法處理的資料類型', str);
        return "";
      }
    },
    getTotalAmount() {
      var totalAmount = 0;
      if (this.pdfData.cost_items) {
        this.pdfData.cost_items.forEach((item) => {
          totalAmount += item.amount;
        });
      }
      return totalAmount;
    },
    splitIntoPages() {
      if (!this.pdfData.cost_items || this.pdfData.cost_items.length === 0) {
        return;
      }

      const rows = this.pdfData.cost_items.map((item, index) => ({
        ...item,
        count: index + 1,
      }));

      if (this.pdfData.payment_steps && this.pdfData.payment_steps.length > 0) {
        const title = this.pdfData.payment_steps_title
          ? `${this.pdfData.payment_steps_title}\n`
          : "";
        const steps = this.pdfData.payment_steps
          .map(
            (step) =>
              `${step.step_phase}${
                step.step_name ? ": " + step.step_name : ""
              } - ${step.step_percentage}% （$${step.step_amount}）`
          )
          .join("\n");
        rows.push(this.buildRemarkRow(`${title}${steps}`));
      }

      // 处理备注
      if (this.pdfData.remark) {
        rows.push(this.buildRemarkRow(this.pdfData.remark));
      }

      this.pages = buildPages({
        rows,
        bodyHeight: TABLE_BODY_HEIGHT,
        descriptionWidth: DESCRIPTION_WIDTH,
        measureRow: this.measureRow,
        getDescription: (row) => this.toPlainText(row.item_description),
        withDescription: (row, text, index) =>
          index === 0
            ? { ...row, item_description: text }
            : { ...row, ...this.buildRemarkRow(text), count: null },
      });

      // 触发更新
      this.$forceUpdate();
    },

    buildRemarkRow(description) {
      return {
        is_remark: true,
        id: null,
        item_description: description,
        quantity: null,
        unit_price: null,
        amount: null,
      };
    },

    // .pdf-item 係 flex 列，高度由最高嗰個欄位決定，唔可以淨係計摘要欄。
    measureRow(row) {
      const isRemark = !!row.is_remark;
      const showsQuantity = !isRemark && Number(row.amount) >= 0;

      const cells = [
        {
          html: this.changeNextLine(row.item_description),
          width: DESCRIPTION_WIDTH,
        },
      ];

      if (showsQuantity) {
        cells.push({ html: String(row.count), width: NO_WIDTH });
        cells.push({
          html: String(parseFloat(Number(row.quantity).toString())),
          width: QUANTITY_WIDTH,
        });
        cells.push({ html: this.getUnitName(row), width: UNIT_WIDTH });
      }

      if (!isRemark) {
        cells.push({
          html: `HK$${this.formatMoney(row.unit_price || 0)}`,
          width: PRICE_WIDTH,
        });
        cells.push({
          html: `HK$${this.formatMoney(row.amount || 0)}`,
          width: PRICE_WIDTH,
        });
      }

      return measureRowHeight(cells);
    },

    getUnitName(row) {
      return row.product && row.product.product_unit
        ? row.product.product_unit.name
        : "次";
    },

    // changeNextLine 已處理各種資料型別，呢度只係反轉返 <br> 做純文字方便切割。
    toPlainText(description) {
      const html = this.changeNextLine(description);
      return html ? html.replace(/<br\s*\/?>/gi, "\n") : "";
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    NoticeToCustomers,
    BFormTextarea,
    BFormInput,
  },
  props: {
    pdfData: {
      type: Object,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  watch: {
    "pdfData.cost_items": {
      handler() {
        this.splitIntoPages();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapFields(["controlValue"]),
  },
  setup(props) {
    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
      company_info: null,
      logo_url: null,
    });

    const getInfo = (template_id, stamp_id) => {
      let template =
        props.templateOptions &&
        props.templateOptions.find((ele) => ele.id == template_id);

      let stamp =
        props.stampOptions &&
        props.stampOptions.find((ele) => ele.id == stamp_id);
      if (template) {
        info.value.website = template.website;
        info.value.address = template.address;
        info.value.phone = template.phone;
        info.value.fax = template.fax;
        info.value.email = template.email;
        info.value.company_info = template.company_info;
        info.value.bank_info = template.bank_info;
        info.value.logo_url = template.logo_url;
      }
      info.value.stamp_url = stamp ? stamp.image_url || '' : '';
    };

    var init = true;

    watch(
      () => props.pdfData,
      (newVal, oldVal) => {
        if (newVal && newVal.template_id && init) {
          getInfo(newVal.template_id, newVal.stamp_id);
          init = false;
        }
      }
    );

    const scale = ref(1);
    const pdfWrapper = ref(null);

    const calculateScale = () => {
      if (pdfWrapper.value) {
        const containerWidth = pdfWrapper.value.offsetWidth;
        const desiredWidth = 793; // A4 紙張寬度（單位：像素）
        scale.value = containerWidth / desiredWidth;
      }
    };

    onMounted(() => {
      calculateScale();
      window.addEventListener("resize", calculateScale);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", calculateScale);
    });

    return {
      info,
      getInfo,
      scale,
      pdfWrapper,
    };
  },
};
</script>

<style lang="scss" scoped>
.pdf-container {
  width: 100%;
  overflow: hidden;
}

.pdf-add-wrapper {
  width: 793px; // A4 紙張寬度
  margin: 0 auto;
  // 其他現有樣式...
}

.stamp_logo {
  top: -40px;
  right: 45px;
}
.pdf-add-wrapper .company-info * {
  font-size: 14px;
}

.remark {
  height: 122px;
}
.paid_stamp {
  width: 100px;
  position: absolute;
  top: 140px;
  width: 200px;
  z-index: 2;
  right: 50%;
  transform: translateX(50%);
}
// pdf
</style>